import { render, staticRenderFns } from "./ForwardingItem.vue?vue&type=template&id=4919f80a&"
import script from "./ForwardingItem.vue?vue&type=script&lang=js&"
export * from "./ForwardingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports